// import ModalForm from "./Form";
import ClassTableForm from "./ClassTableForm";
import { COURSE_HISTORY } from "../../../../../../../Config/ApiUrl";
import { DATATABLE_EXPORT } from "../../../../../../../Config/ApiUrl";
import * as actions from "../../../../../../../Config/ApiUrl";

export const Schema = {
	components: { ClassTableForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			Endpoint:
				COURSE_HISTORY + "?clc_id_number=" + this.value?.clc_id_number,
			tableId: "class-table",
			formId: "class-table-form",
			rowData: {},
			tableColumns: [
				{
					title: "Reference ID",
					type: "custom-html",
					key: "payment_received_id",
					modifier: (value) => {
						return value?.invoice_fk?.reference_id;
					},
				},
				{
					title: "Class Name",
					type: "custom-html",
					key: "course_id",
					modifier: (value) => {
						return value?.course_name;
					},
				},
				{
					title: "Class Type",
					type: "custom-html",
					key: "course_id",
					modifier: (value) => {
						let course_type = value?.course_type_id;
						if (course_type == 1) {
							return "App";
						} else if (course_type == 2) {
							return "Hybrid";
						} else if (course_type == 3) {
							return "Online";
						} else if (course_type == 4) {
							return "Offline";
						}
					},
				},
				{
					title: "CLC Centre",
					type: "custom-html",
					key: "payment_received_id",
					modifier: (value) => {
						return value?.invoice_fk?.center_id?.name;
					},
				},
				{
					title: "Sub Status",
					type: "text",
					key: "sub_status",
				},
				{
					title: "CC",
					type: "custom-html",
					key: "cc_id",
					modifier: (value) => {
						return value?.full_name;
					}
				},
				{
					title: "SC",
					type: "custom-html",
					key: "course_group_id",
					modifier: (value) => {
						return value?.student_care_id?.full_name;
					},
				},
				{
					title: "Main Teacher",
					type: "custom-html",
					key: "course_group_id",
					modifier: (value) => {
						return value?.teach_id?.full_name;
					},
				},
				{
					title: "CO Teacher",
					type: "custom-html",
					key: "course_group_id",
					modifier: (value) => {
						return value?.teach_assistant_id?.full_name;
					},
				},
				{
					title: "Start Week",
					type: "text",
					key: "date_start_clc",
				},
				{
					title: "End Week",
					type: "text",
					key: "date_end_clc",
				},
				{
					title: "Attendance",
					type: "absen-readonly",
					key: "attendance",
				},
			],
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "ClassTable",
				url:
					COURSE_HISTORY +
					"?clc_id_number=" +
					this.value?.clc_id_number,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						// component: "app-add-modal",
						component: "class-table-form",
						modalId: "class-table-form",
					},
					// {
					// 	title: this.$t("delete"),
					// 	icon: "trash",
					// 	type: "none",
					// 	component: "app-confirmation-modal",
					// 	modalId: "demo-delete",
					// },
					{
						title: this.$t("view"),
						icon: "eye",
						type: "page",
						url: "class/class-information",
						target: "", // _blank to open newtab
						uniqueKey: (rowData) => rowData.id,
					},
				],
				// filters: [
				// ],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 3,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {},
};
